import isabellaWhite from "./images/experts/isabella-white.webp";
import josephRodriguez from "./images/experts/joseph-rodriguez.webp";
import masonBrown from "./images/experts/mason-brown.webp";
import robertJones from "./images/experts/robert-jones.webp";
import sophiaAnderson from "./images/experts/sophia-anderson.webp";
import thomasMartinez from "./images/experts/thomas-martinez.webp";
import williamJohnson from "./images/experts/william-johnson.webp";

const experts = [
  {
    name: "Isabella White",
    avatar: isabellaWhite,
  },
  {
    name: "Joseph Rodriguez",
    avatar: josephRodriguez,
  },
  {
    name: "Mason Brown",
    avatar: masonBrown,
  },
  {
    name: "Robert Jones",
    avatar: robertJones,
  },
  {
    name: "Sophia Anderson",
    avatar: sophiaAnderson,
  },
  {
    name: "Thomas Martinez",
    avatar: thomasMartinez,
  },
  {
    name: "William Johnson",
    avatar: williamJohnson,
  },
];

export { experts };
